import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

/**
 * Allows detection of clicks outside of an element.
 */
class ClickAwayListener extends Component {
  /**
   * Initializes a new instance of the ClickAwayListener component.
   * @param {Object} props The component properties.
   */
  constructor(props) {
    super(props);

    this._clickAwayListenerRef = createRef();
  }

  /**
   * Executes when the component has mounted to the DOM.
   */
  componentDidMount() {
    document.addEventListener('click', this._onDocumentClick);
  }

  /**
   * Executes when the component is about to unmount from the DOM.
   */
  componentWillUnmount() {
    document.removeEventListener('click', this._onDocumentClick);
  }

  _onDocumentClick = (e) => {
    // Check if the user clicked outside of our client area.
    if (!this._clickAwayListenerRef?.current?.contains(e.target)) {
      const { onClickAway } = this.props;
      onClickAway && onClickAway(e);
    }
  }

  /**
   * Renders the component.
   */
  render() {
    return (
      <div
        ref={this._clickAwayListenerRef}>
        {this.props.children}
      </div>
    );
  }
}

ClickAwayListener.propTypes = {
  children: PropTypes.node,
  onClickAway: PropTypes.func
};

export default ClickAwayListener;
